import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

/**
 * Interim sink for AV telemetry, posting to the existing AV client-log endpoint.
 *
 * Deliberately thin and deliberately temporary. The durable path is the S3 uploader
 * (294679) and the compaction that follows it; these log lines exist only so a session
 * produces queryable signal before that lands. When the uploader ships, deleting this
 * service and its calls in the reporter should be the whole removal.
 *
 * The route is Chime-named for historical reasons — it predates a second AV vendor and is
 * the established channel for AV client logs. It is wrapped here rather than reached
 * through `chime/ChimeService` so the vendor-agnostic reporter keeps no Chime dependency;
 * the vendor-specific detail stops at this file.
 *
 * Warning level because only warning and error client-log endpoints exist. An aggregate is
 * really informational, but adding an Information endpoint is not worth it for a sink this
 * short-lived, and this is already the de facto channel for routine AV conditions.
 */
@Injectable({ providedIn: 'root' })
export class AvTelemetryLogService {
  static readonly WARNING_LOG_ROUTE = 'videoConferenceMonitoring/sendChimeClientWarningLog';

  constructor(private readonly httpClient: HttpClient) {}

  /**
   * Correlation — package guid, package user guid, device code — is attached by
   * BaseUrlInterceptor and recorded server-side as structured Serilog properties, so the
   * message body carries telemetry only and never restates identity.
   */
  send(message: string): Observable<unknown> {
    return this.httpClient.post<unknown>(AvTelemetryLogService.WARNING_LOG_ROUTE, {
      message: message,
    });
  }
}
